import React from "react";

const SnapsWiseAudio = ({ audioref, fullaudio, timeUpdate }) => {
  return (
    <audio
      preload="auto"
      ref={audioref}
      className="hidden"
      src={fullaudio || ""}
      onTimeUpdate={timeUpdate}
      type="audio/mpeg"
    />
  );
};

export default SnapsWiseAudio;